module.exports = __webpack_public_path__ + "img/play.b9c66e68.svg";